import { PlusIcon } from "@heroicons/react/solid";
import { MeetingViewMeetingNodeNewPageFragmentFragment } from "types/graphql-schema";

import Button from "@components/button/button";
import { ButtonSize } from "@components/button/button-constants";

import { createTopicInMeeting } from "../helpers";

const AddTopicHover = ({
  meeting,
  afterTopicId,
  beforeTopicId,
  hideButton = false,
}: {
  meeting: MeetingViewMeetingNodeNewPageFragmentFragment;
  afterTopicId?: number;
  beforeTopicId?: number;
  hideButton?: boolean;
}) => {
  const handleClickAdd = () => {
    createTopicInMeeting({
      meeting,
      afterTopicId,
      beforeTopicId,
    });
  };

  if (!meeting.canUpdate?.permission) return null;

  return (
    // z-[1] keeps this row in front of the next topic, which is `relative`
    // and would otherwise take the hover below the line. The row stays
    // behind the sticky meeting header (z-10), the topic menu (z-100) and a
    // dragged topic (z-5000).
    <div className="group/add-topic relative z-[1] h-px w-full">
      <div className="h-px bg-gray-200" />
      {!hideButton && (
        <>
          {/* Hover hit area. It spans the full width of the line so the
              button shows wherever the cursor crosses the gap between two
              topics, not only near the centre. It is 24px tall (12px each
              side of the 1px line) and adds no layout height. */}
          <div
            className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-6"
            aria-hidden
          />
          <div className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 top-1/2 h-6 flex items-center">
            <Button
              onClick={handleClickAdd}
              size={ButtonSize.medium}
              className="gap-1 tracking-tight opacity-0 transition-opacity group-hover/add-topic:opacity-100 focus-visible:opacity-100"
            >
              <PlusIcon className="w-4 h-4" />
              Add Topic
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default AddTopicHover;
